

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"6","height":"20","viewBox":"0 0 6 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M3 19.3337L5.88675 14.3337L0.113249 14.3337L3 19.3337ZM2.5 0.666992L2.5 14.8337L3.5 14.8337L3.5 0.666992L2.5 0.666992Z","fill":"#6F627B"}, []), "\n"]);
};

        